export function extractCookiesData(): {
    askConsent: boolean
    marketingAllowed: boolean
    statisticAllowed: boolean
} {
    const cookieInput = document?.querySelector('input[name="__cookie_settings"]') as HTMLInputElement | null
    const defaultData = {
        askConsent: false,
        marketingAllowed: false,
        statisticAllowed: false,
    }

    if (!cookieInput) {
        console.log('[Cookies] Cookie input not found in DOM.')
        return defaultData
    }

    if (!cookieInput.value) {
        console.log('[Cookies] Cookie input exists but is empty.')
        return defaultData
    }

    try {
        const parsed = JSON.parse(cookieInput.value)
        console.log('[Cookies] Parsed cookie data:', parsed)
        return parsed
    } catch (error) {
        console.error('[Cookies] Failed to parse cookie input value:', cookieInput.value, error)
        return defaultData
    }
}
